import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import useAuth from '../../pages/useAuth';
import { useNavigate } from 'react-router-dom';

const Strategy_Dashboard = () => {
     useAuth();
     const navigate = useNavigate();

     return (
          <div style={{ padding: 12, minHeight: '100vh', background: '#f8f9fa' }}>
               <div style={{ maxWidth: 1200, margin: '0 auto' }}>

                    <Row style={{ gap: 12 }}>
                         <Col md={6} xs={12}>
                              <Card style={{ cursor: 'pointer' }} onClick={() => navigate('/employee-attendance')}>
                                   <Card.Body>
                                        <h5>Employee Attendance</h5>
                                        <p style={{ color: '#666' }}>View all employee attendance records and details.</p>
                                        <Button variant="primary" onClick={() => navigate('/employee-attendance')}>Open Attendance</Button>
                                   </Card.Body>
                              </Card>
                         </Col>

                         <Col md={6} xs={12}>
                              <Card style={{ cursor: 'pointer' }} onClick={() => navigate('/employee-attendance-summary')}>
                                   <Card.Body>
                                        <h5>Attendance Summary</h5>
                                        <p style={{ color: '#666' }}>View summary reports for employee attendance.</p>
                                        <Button variant="primary" onClick={() => navigate('/employee-attendance-summary')}>Open Summary</Button>
                                   </Card.Body>
                              </Card>
                         </Col>
                    </Row>
               </div>
          </div>
     );
};

export default Strategy_Dashboard;
